import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const LayoutWithSideFormWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`

export const ContentSide = styled.section`
  flex-grow: 1;
`

export const FormSide = styled.section`
  flex-shrink: 0;
  width: 365px;
  margin-left: ${Spacing.S24};
  padding: ${Spacing.S24} ${Spacing.S32} ${Spacing.S32};
  border-radius: 8px;
  background-color: ${Color.White};
  box-shadow: 0 12px 48px ${transparentize(0.85, Color.Grey500)};
`
